/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chain_Page_Compare_Metric_Avg_Tx_FeeInputs */



/**
* | output |
* | --- |
* | "average transaction fee" |
*
* @param {Chain_Page_Compare_Metric_Avg_Tx_FeeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_metric_avg_tx_fee = /** @type {((inputs?: Chain_Page_Compare_Metric_Avg_Tx_FeeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Metric_Avg_Tx_FeeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("average transaction fee")
});